module.exports = __webpack_public_path__ + "static/media/HAUX_TRAINING_GUIAS_MOBILIDADE.eac644bf.pdf";